import { render, staticRenderFns } from "./SliderAdd.vue?vue&type=template&id=1fd50a86&"
import script from "./SliderAdd.vue?vue&type=script&lang=js&"
export * from "./SliderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports